import { ReactElement, useEffect } from "react";
import { Layout, Menu, Image } from "antd";
import { useAppDispatch, useAppSelector } from "hooks";
import { getSideBarFlag, sidebar } from "redux/features/sidebar";
import Logo from "assets/images/takaful-logo.png";
import "./style.scss";
import { useLocation } from "react-router-dom";
import { SidebarRoutes } from "./SidebarRoutes";
import { getPermittedRoute } from "./service";
import { getAllActiveUser, getAllUserPermission } from "services/globalService";
import { ServerError } from "components/shared/errorNotification/errorNotification";
import { getAllowedPermission, postActiveFeature, postAllowedPermission, getActiveFeature } from "redux/features/permission";
function CustomSidebar(): ReactElement {
  const dispatch = useAppDispatch();
  const allowedPermissionFromStore = useAppSelector(getAllowedPermission) || {};
  const activePermissionFromStore = useAppSelector(getActiveFeature) || {};
  const { Sider } = Layout;
  const location = useLocation();

  const sidebarFlag = useAppSelector(getSideBarFlag);
  const onClickSidebar = () => {
    dispatch(sidebar(!sidebarFlag.disable));
  };

  const getActiveRoutes = async () => {
    try {
      const {
        data: { data }
      } = await getAllActiveUser();
      dispatch(postActiveFeature(data));
    } catch {
      return ServerError();
    }
  };
  const getAllowedPermissioFn = async () => {
    try {
      const {
        data: { data }
      } = await getAllUserPermission();
      dispatch(postAllowedPermission(data));
    } catch {
      return ServerError();
    }
  };
  useEffect(() => {
    getActiveRoutes();
    getAllowedPermissioFn();
  }, [sidebarFlag.reload]);

  const items = [];

  for (const route of SidebarRoutes) {
    const newRoutes = getPermittedRoute(route, activePermissionFromStore, allowedPermissionFromStore);
    if (newRoutes) {
      items.push(newRoutes);
    }
  }

  return (
    <>
      <Sider
        className={"sidebar"}
        theme="light"
        collapsed={sidebarFlag.disable}
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(): void => {
          // console.log(broken);
        }}
        onCollapse={(): void => {
          onClickSidebar();
        }}
        width={300}
      >
        <div className={"logoContainer"}>
          <Image
            src={Logo}
            alt="Takaful bazaar logo"
            rootClassName={"sidebarLogo"}
            preview={false}
          />
        </div>
        <Menu
          defaultSelectedKeys={["1"]}
          mode="inline"
          onClick={e => {
            e.domEvent.stopPropagation();
          }}
          items={items}
          style={{ background: "inherit" }}
          theme="light"
          selectedKeys={[`.${location?.pathname}`]}
          className={"customMenu"}
        />
      </Sider>
    </>
  );
}

export default CustomSidebar;
